module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Peril and Promise of Christian Liberty: Richard Hooker, the Puritans, and Protestant Political Theology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations and Notes on Citations")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Answere")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("John Whitgift. "), _c('i', [_vm._v("An Answere to a certen libell intituled, An Admonition to Parliament.")]), _vm._v(" London: Henrie Bynneman, 1573. Reprinted in "), _c('i', [_vm._v("Whitgift’s Works")]), _vm._v(". Edited by John Ayre. 3 vols. Cambridge: Parker Society, 1849–51.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Corpus Reformatorum")]), _vm._v(". Edited by C. B. Bretschneider and H. E. Bindseil. Halle and Brunswick: C. A. Schwetschke, 1834–.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill and Georges Edelen, eds. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 1: "), _c('i', [_vm._v("The Laws of Ecclesiastical Polity: Pref., Books I to IV")]), _vm._v(". Cambridge, MA: Belknap Press of Harvard University Press, 1977.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill, ed. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 2: "), _c('i', [_vm._v("The Laws of Ecclesiastical Polity, Book V")]), _vm._v(". Cambridge, MA: Belknap Press of Harvard University Press, 1977.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill and P. G. Stanwood, eds. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 3: "), _c('i', [_vm._v("The Laws of Ecclesiastical Polity: Books VI, VII, VIII")]), _vm._v(". Cambridge, MA: Belknap Press of Harvard University Press, 1981.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill and John E. Booty, eds. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 4: "), _c('i', [_vm._v("Of the Lawes of Ecclesiasticall Politie: Attack and Response")]), _vm._v(". Cambridge, MA: Belknap Press of Harvard University Press, 1982.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("5")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill and Laetitia Yeandle, eds. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 5: "), _c('i', [_vm._v("Tractates and Sermons")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Cambridge, MA: Belknap Press of Harvard University Press, 1990.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FLE "), _c('sub', [_vm._v("6")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("W. Speed Hill, ed. "), _c('i', [_vm._v("The Folger Library Edition of the Works of Richard Hooker")]), _vm._v(", vol. 6: "), _c('i', [_vm._v("Of the Lawes of Ecclesiastical Politie, Books I–VIII: Introductions and Commentary")]), _vm._v(". Binghamton, NY: Medieval & Renaissance Texts & Studies, 1993.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("LEP")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Richard Hooker. "), _c('i', [_vm._v("Of the Lawes of Ecclesiastical Politie. Eyght Bookes")]), _vm._v(". London: John Windet, 1593, 1597; Richard Bishop, 1648; J. Best, 1662.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("LW")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Martin Luther. "), _c('i', [_vm._v("Luther’s Works: American Edition")]), _vm._v(". Edited by Jaroslav Pelikan and Helmut T. Lehmann. St. Louis: Concordia, and Philadelphia: Muhlenberg, 1955–1970.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Replye")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Thomas Cartwright. "), _c('i', [_vm._v("A Replye to an Answere Made of M. Doctor Whitgift . . . Agaynste the Admonition")]), _vm._v(". s.l., 1574. Reprinted in "), _c('i', [_vm._v("Whitgift’s Works")]), _vm._v(". Edited by John Ayre. 3 vols. Cambridge: Parker Society, 1849–51.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RSR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Thomas Cartwright. "), _c('i', [_vm._v("The Reste of the Second Replie: Agaynst Master Doctor Whitgifts Second Answer Touching the Church Discipline")]), _vm._v(". Basel, 1577.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("SR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Thomas Cartwright. "), _c('i', [_vm._v("The Second Replie of Thomas Cartwright: Agaynst Master Doctor Whitgifts Second Answer Touching the Church Discipline")]), _vm._v(". Heidelberg, 1575.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ST")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Thomas Aquinas. "), _c('i', [_vm._v("Summa Theologiae")]), _vm._v(". Translated by the Fathers of the English Dominican Province. At New Advent, "), _c('a', {
    attrs: {
      "href": "http://www.newadvent.org",
      "target": "_blank"
    }
  }, [_vm._v("www.newadvent.org")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("WW")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("John Whitgift. "), _c('i', [_vm._v("Whitgift’s Works")]), _vm._v(". Edited by John Ayre. 3 vols. Cambridge: Parker Society, 1849–51.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("Notes on Citations")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Since both Whitgift’s "), _c('i', [_vm._v("Answere")]), _vm._v(" and Cartwright’s "), _c('i', [_vm._v("Replye")]), _vm._v(" were reprinted as part of the text of Whitgift’s 1574 "), _c('i', [_vm._v("Defense of an Answere")]), _vm._v(", which comprises the Parker Society edition of "), _c('i', [_vm._v("Whitgift’s Works")]), _vm._v(", I have simply used that edition for citations of all three sources. So, where the "), _c('i', [_vm._v("Answere")]), _vm._v(" or "), _c('i', [_vm._v("Replye")]), _vm._v(" is cited, I provide the original page #, followed by the "), _c('i', [_vm._v("Whitgift’s Works")]), _vm._v(" page #: so, for instance, “Whitgift, "), _c('i', [_vm._v("Answere")]), _vm._v(", 61 ("), _c('i', [_vm._v("WW")]), _vm._v(" II:44),” or “Cartwright, "), _c('i', [_vm._v("Replye")]), _vm._v(", 14 ("), _c('i', [_vm._v("WW")]), _vm._v(" I:190)”; however, when the citation is from the "), _c('i', [_vm._v("Defense")]), _vm._v(", you will see only, e.g., "), _c('i', [_vm._v("WW")]), _vm._v(" I:235.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All quotations or citations of Richard Hooker are assumed to be from "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("the "), _c('i', [_vm._v("Lawes")]), _vm._v(" unless otherwise specified. They will generally be given by parenthetical references in the main body text (unlike all other citations, which will be footnoted), which will give first the book (in roman numeral), chapter, and paragraph from the "), _c('i', [_vm._v("Lawes")]), _vm._v(", and then the volume (in arabic numeral), page, and line number from the "), _c('i', [_vm._v("Folger Library Edition")]), _vm._v(". So, for instance, the citation “(II.4.3; "), _c('i', [_vm._v("FLE")]), _vm._v(" 1:153.30–154.5)” denotes that the quotation is taken from Book II, ch. 4, par. 3 of the "), _c('i', [_vm._v("Lawes")]), _vm._v(", which can be found in vol. 1, beginning on p. 153, line 30, and ending on p. 154, line 5 of the "), _c('i', [_vm._v("Folger Library Edition")]), _vm._v(". The same format of "), _c('i', [_vm._v("FLE")]), _vm._v(" citations will be used for Hooker’s other works.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 72
// module chunks = 0